var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvalActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-85.8%",
    y: "-64%",
    width: "271.6%",
    height: "271.4%",
    filterUnits: "objectBoundingBox",
    id: "blq9pbe0za"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.712,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.105882353 0 0 0 0 0.219607843 0 0 0 0 0.447058824 0 0 0 0.15 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-59.7%",
    y: "-37.9%",
    width: "219.4%",
    height: "219.2%",
    filterUnits: "objectBoundingBox",
    id: "xcfok3o36c"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.721568627 0 0 0 0 0.956862745 0 0 0 0 0.349019608 0 0 0 1 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "ihnmk0we6b",
    cx: 956.093,
    cy: 268.158,
    rx: 11.485,
    ry: 11.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-933 -250)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#blq9pbe0za)",
    xlinkHref: "#ihnmk0we6b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#1ADB81",
    xlinkHref: "#ihnmk0we6b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#xcfok3o36c)",
    xlinkHref: "#ihnmk0we6b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.424,
    xlinkHref: "#ihnmk0we6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalActive);
export default __webpack_public_path__ + "static/media/oval-active.07213da50e069332181c906736b3ccc4.svg";
export { ForwardRef as ReactComponent };